import { activeChatSelector } from '@src/selectors/chats';
import { connect } from 'react-redux';
import { selectChatContextMenuOption } from '../../actions/agentconsole';
import ChatContextMenu from './ChatContextMenu';

const mapStateToProps = state => ({
  chatContextMenu: state.agentConsole.chatContextMenu,
  chatHistory: state.agentConsole.currentContactChatHistory,
  timeZoneName: state.loginAuthentication.success?.employer?.zoneIdName,
  timeZoneOffset: state.loginAuthentication.success.employer.zoneOffset,
  activeChat: activeChatSelector(state),
});

const mapDispatchToProps = {
  onSelectOption: selectChatContextMenuOption,
};

const ChatContextMenuContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(ChatContextMenu);

export default ChatContextMenuContainer;
